import PaymentInProcess from './PaymentInProcess.container';

export default PaymentInProcess;
